import React, { useState } from "react";
import { Row, Col, Form, Button, Input, Select } from "antd";
import { useSearchParams } from "react-router-dom";

const { Search } = Input;

function FilterMenu(props) {
  const onSearch = (value) => props.onSearch(value);
  const onClear = (value) => props.onClear(value);
  const [searchParams, setSearchParams] = useSearchParams();

  const updateSearchParam = (key, value) => {
    console.log(key);
    const newSearchParams = new URLSearchParams(searchParams);
    if (value !== null) {
      newSearchParams.set(key, value);
    } else {
      newSearchParams.delete(key);
    }
    setSearchParams(newSearchParams);
  };

  return (
    <>
      {/* Menu Bar */}
      <Row
        justify="space-between"
        align="middle"
        style={{ marginBottom: "18px" }}
        gutter={[8, 8]}
      >
        <Col lg={16} xs={24}>
          <Row gutter={[8, 8]} align={"middle"}>
            <Col lg={6} md={6} sm={12} xs={24}>
              <Select
                allowClear
                value={parseInt(searchParams.get("id_privilege")) || null}
                style={{ width: "100%" }}
                placeholder="Select Privilege"
                options={props.optionsPrivilege}
                onChange={(e) => updateSearchParam("id_privilege", e || null)}
              />
            </Col>
          </Row>
        </Col>
        <Col lg={8} xs={24}>
          <Row gutter={[8, 8]} align={"middle"} justify={"end"}>
            <Col xl={12} lg={14} md={6} sm={8} xs={24}>
              <Search
                placeholder="Input username"
                allowClear
                onSearch={onSearch}
                onClear={onClear}
                style={{ width: "100%" }}
              />
            </Col>
            <Col xl={5} lg={7} md={4} sm={6} xs={24}>
              <Button
                type="primary"
                onClick={() => props.onShowAdd(true)}
                style={{ width: "100%" }}
              >
                Add User
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
}

export default FilterMenu;
